export async function request(url, params = {}) {
  let defaultParams = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  params = { ...defaultParams, ...params };

  let response = await fetch("" + url, params);
  return await response.json();
}
